export default function clearFilters() {
	$(document).on('berocket_ajax_filtering_end', function () {
		const params = new URL(document.location).searchParams;
		const filters = params.get('filters');
		if (filters) {
			$('#clear_filters').show();
		} else {
			$('#clear_filters').hide();
		}
	});
}
